module.exports = __webpack_public_path__ + "static/media/person_img.929cc425.png";